module.exports = __webpack_public_path__ + "220ee0cd64ddc6ea0aaf2140f54e41c9.pdf";